// Advisory type keys shared with the entity service (helpers/drilldown.js ADVISORY_TYPE_GROUPS), in display order.
// Every type uses the same orange: advisories are information, not severity levels. `titles` are the
// advisory_types.title values each key covers, used to filter documents by their nested advisories.advisory_type.
export const ADVISORY_TYPES = [
  { value: 'sanctioned', label: 'Sanctioned entity', titles: ['banned-institution', 'banned-funder'] },
  { value: 'military', label: 'Military', titles: ['military-institution'] },
  { value: 'military-affiliated', label: 'Military-affiliated', titles: ['military-affiliated-institution'] },
  { value: 'military-funder', label: 'Military funder', titles: ['military-funder'] },
  { value: 'military-affiliated-funder', label: 'Military-affiliated funder', titles: ['military-affiliated-funder'] },
];

export function advisoryTypeLabel(value) {
  const type = ADVISORY_TYPES.find((t) => t.value === value);
  return type ? type.label : value;
}

// Advisory titles for the selected type keys ([] = all types)
export function advisoryTitles(selected) {
  const keys = selected && selected.length ? selected : ADVISORY_TYPES.map((t) => t.value);
  return ADVISORY_TYPES.filter((t) => keys.includes(t.value)).flatMap((t) => t.titles);
}
